export default __webpack_public_path__ + "36f196206cabdc22afdd468ae0a72e1d.svg";